export default {
  name: 'app-header',
  created: function() {
    if (window.localStorage.getItem('access_token')) {
      this.getNotice()
      this.getIntroductionNotice()
    }
  },
  data () {
    return {
      introductionNoticeCount: 0
    }
  },
  computed: {
    isLogin () {
      return this.$store.getters.isLogin
    },
    isSystemManagement () {
      return this.$store.getters.isSystemManagement
    },
    isHumanStaff () {
      return window.localStorage.getItem('is_human_staff') === '1'
    },
    noticeCount () {
      return this.$store.getters.noticeCount
    },
    isStaging () {
      return process.env.NODE_ENV == 'staging' ? true:false
    }
  },
  methods: {
    logout: function() {
      this.$store.dispatch('LOGOUT')
    },
    /* セッションストレージのクリア */
    clearSessionStrage: function() {
      window.sessionStorage.clear()
    },
    getNotice: function() {
      var data = {'user_id': window.localStorage.getItem('user_id')}

      this.$store.dispatch('NOTICE_COUNT', {data: data} )
    },
    getIntroductionNotice: function () {
      let data = {
      }
      this.$store
        .dispatch('GET_INTRODUCTION_NOTICE_COUNT', { data: data })
        .then(res => {
          this.introductionNoticeCount = res
        })
        .catch(err => console.log(err))
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/app-header.js